/**
 * لون حافّة النافذة في تطبيق PWA — وهو كلّ ما بقي من طبقة «المظهر».
 *
 * ## الوضع داكنٌ دائمًا (أمر المالك 2026-08-11)
 *
 * > «احذف الوضع الفاتح واحذف أي جذور له».
 *
 * وكان ثلاثة أوضاع (تلقائي · داكن · فاتح) بطبقة قيمٍ كاملة في `tokens.css`
 * و`@media (prefers-color-scheme)` وتجاوزٍ في `palettes.css` ومبدّلٍ في
 * الإعدادات. حُذف ذلك كلّه.
 *
 * **والحذف ليس تبسيطًا فحسب**: طبقةٌ ثانية من القيم تعني سطحين يجب قياس
 * تباينهما، وأيّ رمزٍ جديد يحتاج نسختين — ونسيان الثانية يمرّ أخضر في كل
 * البوابات ويظهر عند المالك وحده على شاشته.
 */

/** أرضية البالتة الافتراضية — المصدر الوحيد لها `tokens.css`، وهذه نسخة العرض. */
const THEME_COLOR = '#0F1216';

/**
 * يثبّت الوضع الداكن على الجذر ويضبط لون الحافّة.
 *
 * و`data-theme='dark'` تُكتب صراحةً لا تُترك للغياب: `index.html` يقرؤها في
 * سكربت ما قبل الرسم، ووسمُها الصريح يجعل الحالة **معلنة** بدل أن تكون
 * افتراضًا صامتًا يسهل نقضُه.
 */
export function applyDarkTheme(): void {
  const root = document.documentElement;
  root.setAttribute('data-theme', 'dark');

  /*
   * وسم `theme-color` واحد يُحدَّث بـ JS لا وسمان بمُحدِّدَي media: المتصفح
   * يختار أول وسم يطابق تفضيل **النظام**، وذلك كان يترك حافّة نافذة الـPWA
   * على غير لون التطبيق. والقيمة أرضية البالتة الافتراضية — وفرق أرضيات
   * البالتات الست عنها أقلّ من أن يُرى على حافّة نافذة.
   */
  let meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
  if (meta === null) {
    meta = document.createElement('meta');
    meta.name = 'theme-color';
    document.head.appendChild(meta);
  }
  meta.content = THEME_COLOR;
}
